if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.section;

        this.form = document.getElementById(
          `product-form-${this.sectionId}`
        );

        this.input = this.form
          ? this.form.querySelector('input[name="id"]')
          : null;

        this.installmentInput = document
          .getElementById(`product-form-installment-${this.sectionId}`)
          ?.querySelector('input[name="id"]');

        this.variantData = [];

        const scriptTag = this.querySelector(
          'variant-selects [type="application/json"]'
        );

        if (scriptTag) {
          try {
            const rawData = JSON.parse(scriptTag.textContent);

            this.variantData = Array.isArray(rawData)
              ? rawData
              : rawData.variants || Object.values(rawData);
          } catch (e) {
            this.variantData = [];
          }
        }
      }

      connectedCallback() {
        this.addEventListener(
          'change',
          this.handleOptionValueChange.bind(this)
        );
      }

      handleOptionValueChange() {
        this.updateVariant();
      }

      updateVariant() {
        if (!Array.isArray(this.variantData)) return;

        const selectedOptions = Array.from(
          this.querySelectorAll(
            'variant-selects fieldset input:checked, variant-selects select'
          ),
          (input) => input.value
        );

        this.currentVariant = this.variantData.find((variant) => {
          if (!variant || !Array.isArray(variant.options)) {
            return false;
          }

          if (variant.options.length !== selectedOptions.length) {
            return false;
          }

          return variant.options.every(
            (option, index) => option === selectedOptions[index]
          );
        });

        this.updateMasterId();
        this.updateSubmitButton();

        if (this.currentVariant) {
          this.updateURL();
        }
      }

      updateMasterId() {
        const variant = this.currentVariant;

        if (this.input) {
          this.input.value = variant ? variant.id : '';
          this.input.disabled = !variant || !variant.available;
        }

        if (this.installmentInput) {
          this.installmentInput.value = variant ? variant.id : '';
          this.installmentInput.disabled = !variant || !variant.available;
        }
      }

      updateURL() {
        if (
          !this.currentVariant ||
          this.dataset.updateUrl === 'false'
        ) {
          return;
        }

        window.history.replaceState(
          {},
          '',
          `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      }

      updateSubmitButton() {
        const submitButton = this.form?.querySelector(
          '[type="submit"]'
        );

        if (!submitButton) return;

        const variant = this.currentVariant;
        const isAvailable = Boolean(variant && variant.available);

        submitButton.toggleAttribute('disabled', !isAvailable);

        const submitButtonText = submitButton.querySelector('span');
        if (!submitButtonText) return;

        if (!variant) {
          submitButtonText.textContent =
            window.variantStrings?.unavailable || 'Unavailable';
        } else if (variant.available) {
          submitButtonText.textContent =
            window.variantStrings?.addToCart || 'Add to cart';
        } else {
          submitButtonText.textContent =
            window.variantStrings?.soldOut || 'Sold out';
        }
      }
    }
  );
}

document.addEventListener('change', (event) => {
  if (event.target.name && event.target.name.includes('options')) {
    const productInfo = event.target.closest('product-info');

    if (productInfo && productInfo.currentVariant) {
      productInfo.updateMasterId();
    }
  }
});